export default "__VITE_ASSET__BpVYOvsS__"